import React from 'react';
import { 
    BsGearFill, 
    BsBoxSeamFill, 
    BsTruck, 
    BsCheckCircleFill
} from 'react-icons/bs';

const OrderStatusIcons = ({ status, className = "" }) => {
    // This is a placeholder component - replace with your preferred icon library
    
    const getIcon = (status) => {
        switch (status) {
            case 'processed':
                return <BsGearFill className={className} />;
            
            case 'shipped':
                return <BsBoxSeamFill className={className} />;
            
            case 'on-the-way':
                return <BsTruck className={className} />;
            
            case 'delivered':
                return <BsCheckCircleFill className={className} />;
            
            default:
                return null;
        }
    };

    return getIcon(status);
};

export default OrderStatusIcons;

// Usage example in your Orders component:
/*
import OrderStatusIcons from './OrderStatusIcons';

// In your JSX:
<div className="progress-label processed">
    <OrderStatusIcons status="processed" />
</div>

<div className="progress-label shipped">
    <OrderStatusIcons status="shipped" />
</div>

<div className="progress-label on-the-way">
    <OrderStatusIcons status="on-the-way" />
</div>

<div className="progress-label delivered">
    <OrderStatusIcons status="delivered" />
</div>
*/

// The component now uses Bootstrap Icons:
// - BsGearFill for processed status (gear icon representing processing)
// - BsBoxSeamFill for shipped status (filled box icon representing packaging)
// - BsTruck for on-the-way status (truck icon representing delivery)
// - BsCheckCircleFill for delivered status (check circle icon representing completion) 